export function parseBet(bet: string): number {
  const numBet = Number(bet);

  if (Number.isNaN(numBet)) {
    return 0;
  }

  return Math.abs(numBet);
}
